import { useAuth } from "@/lib/auth";

export default function Impostazioni() {
  const { user } = useAuth();

  return (
    <div className="max-w-3xl">
      <div className="adr-overline mb-3">Impostazioni</div>
      <h1 className="serif text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A] mb-8">
        Il tuo profilo
      </h1>

      <div className="adr-card p-6 mb-6">
        <h2 className="serif text-lg font-semibold mb-4">Dati account</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <Info label="Nome" value={user?.full_name} />
          <Info label="Email" value={user?.email} />
          <Info label="Ruolo" value={user?.role} capitalize />
          <Info label="Organizzazione" value={user?.organization?.name} />
        </div>
      </div>

      <div className="adr-card p-6">
        <h2 className="serif text-lg font-semibold mb-3">Privacy e dati</h2>
        <p className="text-sm text-[#555555] leading-relaxed mb-3">
          ADRIAI Builder tratta i tuoi dati nel rispetto del GDPR. I file e i risultati dei lavori restano accessibili solo agli utenti della tua organizzazione. I prompt sono inviati al provider LLM configurato (Anthropic) tramite chiave universale Emergent.
        </p>
        <p className="text-sm text-[#555555] leading-relaxed">
          Per esercitare i tuoi diritti (accesso, rettifica, cancellazione, portabilità) scrivi a privacy@confindustria-medioadriatico.it.
        </p>
      </div>
    </div>
  );
}

const Info = ({ label, value, capitalize }) => (
  <div>
    <div className="text-xs uppercase tracking-wider text-[#555555] mb-1">{label}</div>
    <div className={`text-sm text-[#1A1A1A] ${capitalize ? "capitalize" : ""}`}>{value || "—"}</div>
  </div>
);
